import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import Finanacemanagement from "../../models/financemanagement.modal";
import Tutorsmodel from "../../models/tutors.modal";
import ClassModal from "../../models/class.modal";
import AttendanceModel from "../../models/Attendance.modal";
import Loader from "components/loader/Loader";

const DraftTutorsSalary = () => {
  const [classlist, setClasslist] = useState();
  const [cycle, setCycle] = useState();
  const [classId, setClassId] = useState();
  const [tutorlist, setTutorlist] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [data, setData] = useState();
  const [Id, setId] = useState();
  const parmas = useParams();
  const [status, setStatus] = useState("All");
  // edit draft
  const EditDraft = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    const Cyclecompletiondate = form.get("cycle_completion_date");
    if (Cyclecompletiondate) {
      const [year, mm, dd] = Cyclecompletiondate.split("-");
      const orginalcycle = `${dd}/${mm}/${year}`;
      form.set("cycle_completion_date", orginalcycle);
    }

    const paymentduedate = form.get("payment_due_date");
    if (paymentduedate) {
      const [yyy, mmm, ddd] = paymentduedate.split("-");
      const orginalpaymentdate = `${ddd}/${mmm}/${yyy}`;
      form.set("payment_due_date", orginalpaymentdate);
    }
    Finanacemanagement.EditDraftTutor(Id, form)
      .then((responce) => {
        helper.sweetalert.toast(responce.data?.message, "success");
        listooSalary();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("check list of tutor", tutorlist);
  // marked as paid
  const MartoPaid = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("payment_for", "salaryDraft");
    form.append("salary_invoice_id", Id);
    const originalDate = form.get("date");

    if (originalDate) {
      const [year, month, day] = originalDate.split("-");
      const formattedDate = `${day}-${month}-${year}`;
      form.set("date", formattedDate);
    }
    Finanacemanagement.markedinvoicepaid(form)
      .then((responce) => {
        helper.sweetalert.toast(responce.data?.message, "success");
        listooSalary();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  // Add draft tutor
  const addDrafttutor = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    const Cyclecompletiondate = form.get("cycle_completion_date");
    if (Cyclecompletiondate) {
      const [year, mm, dd] = Cyclecompletiondate.split("-");
      const orginalcycle = `${dd}/${mm}/${year}`;
      form.set("cycle_completion_date", orginalcycle);
    }

    const paymentduedate = form.get("payment_due_date");
    if (paymentduedate) {
      const [yyy, mmm, ddd] = paymentduedate.split("-");
      const orginalpaymentdate = `${ddd}/${mmm}/${yyy}`;
      form.set("payment_due_date", orginalpaymentdate);
    }
    Finanacemanagement.AddDraftTutor(form)
      .then((responce) => {
        console.log("hi", responce);
        helper.sweetalert.toast(responce?.data?.message, "success");
        listooSalary();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  // get cycle by classid
  const GetCycle = async (id) => {
    if (id) {
      AttendanceModel.getcycle(id)
        .then((resposnce) => {
          setCycle(resposnce?.data?.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  // my code(firdosh)
  const Getclasslist = async (id) => {
    let tutorContact;
    console.log("tutor --------------> ", tutorlist);
    tutorlist?.map((item, index) => {
      if (item?.user?.id == id) {
        tutorContact = item?.mobile;
      }
    });
    if (tutorContact) {
      AttendanceModel.getclassbytutor(tutorContact)
        .then((responce) => {
          setClasslist(responce?.data?.data);
        })
        .catch((error) => {});
    }
  };
  // get tutor list for dropdown

  const TutorlistAll = async () => {
    Tutorsmodel.GetAllTutor()
      .then((responce) => {
        setTutorlist(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  // get class list for dropdown

  // get tutor salary lsit
  const listooSalary = async () => {
    setIsLoading(true);
    if (status == "All") {
      Finanacemanagement.GetTutorSalaryListAll()
        .then((responce) => {
          setData(responce?.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log("error", error);
          setIsLoading(true);
        });
    } else {
    }
    Finanacemanagement.GetTutorSalaryList(status)
      .then((responce) => {
        setData(responce?.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const searchbydate = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const form = new FormData(event.target);
    const from = form.get("from_date");
    const to = form.get("to_date");
    const status = form.get("status");
    Finanacemanagement.listOfInvoiceDatee(from, to, status)
      .then((result) => {
        setIsLoading(false);

        console.log("invoice list", result);
        setData(result?.data);
        // if (result) {
        //  setDataList(result?.data);
        //  setCurrentPage(result?.meta?.current_page);
        //  setPerPage(result?.meta?.per_page);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    listooSalary();
  }, [status]);
  useEffect(() => {
    listooSalary();
    TutorlistAll();
  }, []);

  const [alldata, setAlldata] = useState([]);
  const [pendingdata, setPendingdata] = useState([]);
  const [unpaiddata, setUnpaiddata] = useState([]);
  const [paiddata, setPaiddata] = useState([]);
  const [voiddata, setVoiddata] = useState([]);

  const datacount = async () => {
    Finanacemanagement.GetTutorSalaryListAll()
      .then((responce) => {
        setAlldata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    Finanacemanagement.GetTutorSalaryList("Pending")
      .then((responce) => {
        setPendingdata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    Finanacemanagement.GetTutorSalaryList("Unpaid")
      .then((responce) => {
        setUnpaiddata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    Finanacemanagement.GetTutorSalaryList("Completed")
      .then((responce) => {
        setPaiddata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    Finanacemanagement.GetTutorSalaryList("Void")
      .then((responce) => {
        setVoiddata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    datacount();
  }, []);
  console.log("data cout of draft", alldata);
  const getListDataLevel = async () => {
    setIsLoading(true);

    await levelModal
      .list()
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (parmas.mid != "") {
      getListDataLevel();
    }
  }, []);

  // const du = new DeviceUUID();
  // const uuid = du.get();
  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggle2 = () => {
    setModal2(!modal2);
  };

  const [ListLevel, setListLevel] = useState();
  const [levelId, setLevelId] = useState("");
  const getListBylevelId = async () => {
    // setLevelId(id);
    setIsLoading(true);
    await levelModal
      .listbyLevelid(levelId)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setListLevel(result?.data?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    if (levelId !== "") {
      getListBylevelId();
    }
  }, [levelId]);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");
  const [priceStart, setPriceStart] = useState(""); // State to store start time
  const [priceUpto, setPriceUpTO] = useState(""); // State to store end time
  const [name, setName] = useState();

  // Function to handle changes in the start time input
  const handlepriceStart = (event) => {
    const { value } = event.target;
    setPriceStart(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handlePriceUpto = (event) => {
    const { value } = event.target;
    setPriceUpTO(value); // Update endTime state with the selected time
  };

  const handleName = (event) => {
    const { value } = event.target;
    setName(value); // Update endTime state with the selected time
  };

  const [inputsAbout, setInputsAbout] = useState([{ id: 1, value: "" }]);

  const handleInputChangeAbout = (index, event) => {
    const values = [...inputsAbout];
    values[index].value = event.target.value;
    setInputsAbout(values);
  };
  const inputsProvalues = inputsAbout && inputsAbout?.map((item) => item.value);
  const handleAddInputAbout = () => {
    const newInputs = [
      ...inputsAbout,
      { id: inputsAbout.length + 1, value: "" },
    ];
    setInputsAbout(newInputs);
  };
  const handleRemoveInputAbout = (index) => {
    if (inputsAbout?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsAbout];
    values.splice(index, 1);
    setInputsAbout(values);
  };

  const clearState = () => {
    setPriceStart("");
    setPriceUpTO("");
    setName("");
    setInputsAbout("");
  };

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      name: name,
      price_start: parseInt(priceStart),
      price_upto: parseInt(priceUpto),
      about: inputsProvalues,
    };
    levelModal
      .createLelvel(data)
      .then((response) => {
        clearState();
        getListDataLevel();
        helper.sweetalert.toast(response.message, "success");
        toggle();
        setAddsLoadig(false);
      })
      .catch((error) => {
        setAddsLoadig(false);
      });
  };

  const [formData, setFormData] = useState({
    name: "",
    price_start: "",
    price_upto: "",
  });

  useEffect(() => {
    // Set default values when the component mounts
    if (ListLevel) {
      setFormData({
        name: ListLevel?.name || "",
        price_start: ListLevel.price_start || "",
        price_upto: ListLevel.price_upto || "",
      });
    }
  }, [ListLevel]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [inputseditDesc, setInputseditDess] = useState([]);

  useEffect(() => {
    if (ListLevel && ListLevel.about) {
      setInputseditDess(
        ListLevel.about.map((value, index) => ({
          id: index,
          value: value || "",
        }))
      );
    }
  }, [ListLevel]);

  // Function to handle changes in the edit description input fields
  const handleInputChangeeditDesc = (index, event) => {
    const values = [...inputseditDesc];
    values[index].value = event.target.value;
    setInputseditDess(values);
  };

  // Function to handle adding a new edit description input field
  const handleAddInputeditDesc = () => {
    const newInputs = [
      ...inputseditDesc,
      { id: inputseditDesc.length, value: "" },
    ];
    setInputseditDess(newInputs);
  };

  // Function to handle removing an edit description input field
  const handleRemoveInputeditDesc = (index) => {
    if (inputseditDesc.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputseditDesc];
    values.splice(index, 1);
    setInputseditDess(values);
  };
  const inputsProvalueseditDesc =
    inputseditDesc && inputseditDesc?.map((item) => item.value);

  const handleSubmitEditLevel = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      id: levelId,
      name: formData.name,
      price_start: parseInt(formData.price_start),
      price_upto: parseInt(formData.price_upto),
      about: inputsProvalueseditDesc,
    };

    levelModal
      .editLevel(data)
      .then((response) => {
        getListDataLevel();
        helper.sweetalert.toast(response.message, "success");
        setFormData("");
        toggle1();
        setAddsLoadig(false);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data.message, "error");
        console.log(error, "error");
        setAddsLoadig(false);
        setFormData("");
      });
  };
  // delete draft
  const handleDel = async (delId) => {
    Finanacemanagement.DeleteDraftTutor(delId)
      .then((res) => {
        helper.sweetalert.toast(res.data?.message);
        listooSalary();
      })

      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  const [searchTerm, setSearchTerm] = useState("");

  // Filtered data based on the search term
  const currentData = status === "All" ? alldata : data;
  const filteredData = currentData?.filter((item) => {
    const fullName = `${item?.tutorInfo?.first_name || ""} ${
      item?.tutorInfo?.last_name || ""
    }`;
    const username = item?.tutorInfo?.username || "";
    return (
      fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      username.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });
  return (
    <div className="pt-7 px-4">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0  align-items-center ">
              <div>
                <h3 className="mb-0">Draft Tutors Salary List</h3>
              </div>
              <form onSubmit={searchbydate}>
                <div className="d-flex flex-row mt-2 ">
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Filters{" "}
                  </p>
                  <span
                    className="mr-2 d-flex "
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      marginTop: "3px",
                    }}
                  >
                    From
                  </span>
                  <Input
                    className="mr-4"
                    type="date"
                    placeholder="Search"
                    size="sm"
                    style={{ width: "200px" }}
                    name="from_date"
                  />

                  <span
                    className="mr-2"
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      marginTop: "3px",
                    }}
                  >
                    To{" "}
                  </span>
                  <Input
                    className="mr-4"
                    type="date"
                    placeholder="Search"
                    size="sm"
                    style={{ width: "200px" }}
                    name="to_date"
                  />
                  {/* <Input
                    id="forType"
                    name="status"
                    type="select"
                    size="sm"
                    style={{ width: "200px" }}
                  >
                    <option value="">Select Status</option>
                    <option value="">All</option>
                    <option value="Void">Void</option>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Paid</option>
                  </Input>*/}
                  <div className="position-relative ml-2">
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search by Name or Mobile no"
                      size="sm"
                      style={{ width: "200px", paddingLeft: "30px" }}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} // Update search term
                    />
                    <i
                      className="fa fa-search position-absolute"
                      style={{
                        top: "40%",
                        left: "15px",
                        transform: "translateY(-50%)",
                        fontSize: "14px",
                        color: "#aaa",
                      }}
                    ></i>
                  </div>
                  {/* <Button
                  size="sm"
                  onClick={toggle}
                  style={{
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    width:"150px",
                    height:"30px"
                  }}
                >
                  +Add
                </Button> */}

                  <Button
                    size="sm"
                    // onClick={toggle}
                    style={{
                      backgroundColor: "orange",
                      color: "white",
                      border: "none",
                      width: "150px",
                      height: "30px",
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    size="sm"
                    // onClick={toggle}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "3px solid gray",
                      width: "150px",
                      height: "30px",
                    }}
                    onClick={toggle}
                  >
                    +Add
                  </Button>
                </div>
              </form>
            </CardHeader>
            <Row
              className="mb-1"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                md={8}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="me-3 pl-5"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "All" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("All");
                  }}
                >
                  <span>All</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "All" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {alldata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Unpaid" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Unpaid");
                  }}
                >
                  <span>Unpaid</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Unpaid" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {unpaiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Pending" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Pending");
                  }}
                >
                  <span>Pending</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Pending" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {pendingdata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Completed" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Completed");
                  }}
                >
                  <span>Paid</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Paid" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {paiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Void" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Void");
                  }}
                >
                  <span>Void</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Void" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {voiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
              </Col>
            </Row>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th style={{ padding: "0.rem" }} scope="col">
                    #
                  </th>
                  {/* <th scope="col">CLASS ID</th> */}
                  <th scope="col"> Tutors's Name (Mobile)</th>
                  <th scope="col"> Student</th>
                  <th scope="col">Payment Amount</th>
                  <th scope="col">Status</th>
                  {/* <th scope="col">Transaction Id</th> */}

                  <th scope="col">Remark</th>
                  <th scope="col">Last Payment Date</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center align-middle w-full"
                    >
                      Please wait...
                      <Loader />
                    </td>
                  </tr>
                ) : filteredData?.length > 0 ? (
                  filteredData.map((item, index) => {
                    return (
                      <tr key={item._id} style={{ cursor: "pointer" }}>
                        <td style={{ padding: "0.rem" }}>{index + 1}</td>

                        <td style={{ padding: "0.rem" }}>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div>
                              {item?.tutorInfo?.first_name || "-"}{" "}
                              {item?.tutorInfo?.last_name}
                            </div>{" "}
                            <div>{item?.tutorInfo?.username}</div>{" "}
                          </div>
                        </td>
                        <td style={{ padding: "0.rem" }}>
                          {item?.classInfo?.name || "-"}
                        </td>
                        <td style={{ padding: "0.rem" }}>
                          {item?.total_amount || "-"}
                        </td>
                        <td style={{ padding: "0.rem" }}>
                          {item?.status || "-"}
                        </td>

                        <td style={{ padding: "0.rem" }}>
                          {item?.remark || "-"}
                        </td>
                        <td style={{ padding: "0.rem" }}>
                          {item?.payment_due_date || "-"}
                        </td>

                        <td
                          className="p-0"
                          style={{
                            padding: "0.3rem",
                            // justifyContent: "center",
                            // alignItems: "center",
                          }}
                        >
                          {/* <UncontrolledTooltip
                            placement="top"
                            target="eyeTooltip"
                          >
                            Edit
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "3px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "0px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="eyeTooltip"
                            // to={`/admin/classes/editclasss/${item?.id}`}
                            onClick={() => {
                              toggle1();
                              setId(item?.id);
                            }}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Link>*/}

                          <UncontrolledTooltip
                            placement="top"
                            target="userTooltip"
                          >
                            Delete
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "3px",
                              fontSize: "15px",
                              color: "red",
                              marginTop: "10px",
                              // backgroundColor: "#f5f5f5",
                              display: "inline-block",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "20%", // Optional: Make it a circle
                            }}
                            id="userTooltip"
                            onClick={() => handleDel(item.id)}
                          >
                            <i className="fas fa-trash"></i>
                          </p>

                          <UncontrolledTooltip placement="top" target="viewws">
                            Views
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "3px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="viewws"
                            to={`/admin/draftPaymentOrader/${item?.tutor_id}`}
                          >
                            <i class="fa-solid fa-eye"></i>
                          </Link>
                          {item?.status !== "Completed" && (
                            <>
                              <UncontrolledTooltip
                                placement="top"
                                target="Attendenc"
                              >
                                Mark to Paid
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "3px",
                                  fontSize: "15px",
                                  color: "green",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="Attendenc"
                                //to={`/admin/attendance`}
                                onClick={() => {
                                  toggle2();
                                  setId(item?.id);
                                }}
                              >
                                <i className="fas fa-check"></i>
                              </Link>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ textAlign: "center", padding: "1rem" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <h4>Tutor Draft Salary Add</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={addDrafttutor}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Tutor</Label>
                  <Input
                    type="select"
                    name="tutor_id"
                    onChange={(e) => {
                      Getclasslist(e.target.value);
                    }}
                  >
                    <option value="">Select tutor</option>
                    {tutorlist?.map((item, index) => {
                      console.log("dta verify", item);
                      return (
                        <option key={index} value={item?.user?.id}>
                          {item?.user?.first_name} {item?.user?.last_name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label> Class</Label>
                  <Input
                    name="class_id"
                    type="select"
                    onChange={(e) => {
                      GetCycle(e.target.value);
                    }}
                  >
                    <option value="">Select Class</option>
                    {classlist?.map((item, index) => {
                      return <option value={item?.id}>{item?.name}</option>;
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Cycle</Label>
                  <Input name="cycle_id[]" type="select">
                    <option value="">Select Cycle</option>
                    {cycle?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.cycle_number}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Amount</Label>
                  <Input
                    name="total_amount"
                    type="text"
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Bonus Note</Label>
                  <Input
                    type="text"
                    name="bonus_note"
                    placeholder="Enter Bonus Note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Total Bonus Amount</Label>
                  <Input
                    type="text"
                    name="total_bonus_amount"
                    placeholder="Enter Bonus Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Deduction Note</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    placeholder="Enter Deduction Note"
                    type="text"
                    name="deduction_note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Total Deduction Amount</Label>
                  <Input
                    type="text"
                    name="total_deduction_amount"
                    placeholder="Enter Deduction Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Cycle completion date</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="forType"
                    type="date"
                    name="cycle_completion_date"
                    // onChange={handleName}
                    // value={name}
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Payment due Date</Label>
                  <Input
                    type="date"
                    name="payment_due_date"
                    placeholder="Enter Payment due Date"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Remark</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="textarea"
                    name="remark"
                    placeholder="Enter Remark "
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal1} toggle={toggle1} size="lg">
        <ModalHeader toggle={toggle1}>
          <h4>Tutor Draft Salary Edit</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={EditDraft}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Tutor</Label>
                  <Input name="tutor_id" type="select">
                    <option value="">select</option>
                    {tutorlist?.map((item, index) => {
                      return (
                        <option key={index} value={item?.user?.id}>
                          {item?.user?.first_name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label> Class</Label>
                  <Input
                    type="select"
                    name="class_id"
                    onChange={(e) => {
                      GetCycle(e.target.value);
                    }}
                  >
                    <option value="driver">Select Client</option>
                    {classlist?.map((item, index) => {
                      return <option value={item?.id}>{item?.name}</option>;
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Cycle</Label>
                  <Input type="select" name="cycle_id[]">
                    <option value="">Select Cycle</option>
                    {cycle?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.cycle_number}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Amount</Label>
                  <Input
                    name="total_amount"
                    type="text"
                    placeholder="Enter Amount"
                  ></Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Bonus Note</Label>
                  <Input
                    name="bonus_note"
                    type="text"
                    placeholder="Enter Bones notes"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Total Bonus Amount</Label>
                  <Input
                    name="total_bonus_amount"
                    type="text"
                    placeholder="Enter Bonus Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Deduction Note</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    name="deduction_note"
                    placeholder="Enter Deduction note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Total Deduction Amount</Label>
                  <Input
                    type="text"
                    name="total_deduction_amount"
                    placeholder="Total Deduction Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Cycle completion date</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    name="cycle_completion_date"
                    type="date"
                    placeholder="Enter Cycle completion date "
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Payment due Date</Label>
                  <Input
                    type="date"
                    name="payment_due_date"
                    placeholder="Enter Due Date"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Remark</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="textarea"
                    name="remark"
                    placeholder="Enter Remark "
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle1}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} size="md">
        <ModalHeader toggle={toggle2}>
          <h4>Mark to Paid</h4>
        </ModalHeader>

        <ModalBody>
          <Form onSubmit={MartoPaid}>
            <Row>
              <Col md={12}>
                <Label>Amount Paid</Label>
                <Input
                  type="text"
                  placeholder="Enter Invoice id "
                  name="amount_paid"
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Date</Label>
                <Input type="date" name="date" />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Pay mode</Label>
                <Input type="select" name="pay_mode">
                  <option value="Cash">CASH</option>
                  <option value="Neft/Imps">NEFT/IMPS</option>
                  <option value="Upi">UPI</option>
                  <option value="Others">Others</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Reciept</Label>
                <Input
                  type="file"
                  name="reciept"
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Transaction id</Label>
                <Input type="text" name="transaction_id" />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Remark</Label>
                <Input name="remark" type="textarea" />
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle2}>
                Cancel
              </Button>

              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle2}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DraftTutorsSalary;
